// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__2rX-v","content":"GlobalSearch_content__2iirZ"};